<section class="blog single-blog section " style="padding-top: 10px !important;">
    <div class="container container-xs">
        <div class="row">


            <div class="col-xxl-9 col-md-9 col-sm-9 col-xs-12 m-xs-0 animated fadeIn">
                <div class="row" *ngIf="loading">
                    <div class="col-12">
                        <div class="alert alert-info text-center">
                            <h4 class="alert-heading">Cargando</h4>
                            <i class="fa fa-sync fa-spin fa-3x"></i>
                            <p class="mb-0">Espera por favor...</p>
                        </div>
                    </div>
                </div>

                <article class="single-post">
                    <div class="caminodemigas">
                        <a href="#"><i _ngcontent-hdm-c23="" class="fa fa-1x fa-home"></i></a>&nbsp;
                        <span *ngIf="pregunta"><a (click)="gotoTemas(pregunta.burbujaId, pregunta.desBurbuja)">{{(pregunta.desBurbuja.length>24)? (pregunta.desBurbuja | slice:0:24)+'..':(pregunta.desBurbuja)}}</a>
                      <i class="fas fa-chevron-right mr-1 ml-1"></i> <a (click)="gotoPreguntas(pregunta.temaId)">{{(pregunta.desTema.length>24)?(pregunta.desTema | slice:0:24)+'..':(pregunta.desTema)}}</a></span>
                    </div>
                    <h2 *ngIf="pregunta" class="tit_respuesta" style="cursor: default;"> <a type="button" class="btn btn-link" (click)="volver()"><i class="fas fa-arrow-left"></i> </a> {{pregunta.desPregunta}}</h2>
                    <button id="edit" class="btn btn-primary editar mr-3 mt-3" type="button" (click)="habilitarGuardar($event.target)" tipo="editar" *ngIf="isAdmin||isContribuidor && pregunta?.respuesta!==null"><i class="far fa-edit"></i> Editar</button>
                    <button id="guardar" class="btn btn-success guardar mr-3 mt-3" type="button" (click)="saveRespuesta($event.target)" *ngIf="(isAdmin||isContribuidor) && pregunta?.respuesta!==null && editar"><i class="far fa-save"></i> Guardar</button>
                    <p *ngIf="pregunta" class="click2edit" [innerHTML]="html">
                    </p>
                    <hr>
                    <div class="form-group">
                        <div class="badge badge-light" [innerHTML]="hashtags"></div>
                        <button type="button" *ngIf="(isAdmin||isContribuidor) && verBtnEditarHash && pregunta?.respuesta!==null " (click)="verEditarHash()" class="btn btn-link editar_hash btn-sm"><i class="far fa-edit"></i>  Editar hashtag</button>
                        <form autocomplete="off" [formGroup]="formuHash" (ngSubmit)="guardarHash()" *ngIf="editarHash">
                            <div class="form-group row">
                                <div class="col">
                                    <input class="form-control" type="text" placeholder="Hashtag" formControlName="hashtag" [class.is-invalid]="hashtagNoValido" maxlength="300" class="input_hash w-75" />
                                    <small *ngIf="hashtagNoValido" class="text-danger">
                               {{textoHashInvalido}}
                              </small><br>
                                    <button (click)="cancelEditarHash()" class="btn editar mr-3 mt-3 btn-danger"><i class="fas fa-times"></i> Cancelar</button>&nbsp;
                                    <button [disabled]="hashtagNoValido" class="btn btn-success guardar mr-3 mt-3"><i class="fas fa-save"></i> Guardar hashtag</button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <hr>

                    <div class="cont_publica">
                        <div class="input-group mt-3" *ngIf="(isAdmin||isContribuidor) && pregunta?.respuesta!==null">
                            <span class="input-group-text" id="basic-addon1" style="margin-top: 5px;color: #b5b2b2;font-size: 1em;font-weight: 400;">Respuesta pública</span>
                            <div class="onoffswitch2" style="margin-left: 10px;">
                                <input type="checkbox" name="onoffswitch2" class="onoffswitch2-checkbox" id="myonoffswitch2" [checked]="pregunta?.esPrivado==null?'True':pregunta.esPrivado" (change)="esPublico($event)">
                                <label class="onoffswitch2-label" for="myonoffswitch2">
                                        <span class="onoffswitch2-inner"></span>
                                        <span class="onoffswitch2-switch"></span>
                            </label>
                            </div>
                        </div>
                    </div>

                </article>

                <span *ngIf="muestraFeed">
                  <!-- feedback Widget -->
                  <app-feedback [idRespuesta]="pregunta.respuestaId" *ngIf="pregunta?.respuesta!==null"></app-feedback>
                  <!-- feedback Widget -->
               </span>
            </div>
            <div class="col-xxl-3 col-md-3 col-sm-3 col-xs-12 m-xs-0 pr-md-0 animated fadeIn">
                <div class="sidebar">

                    <div class="widget related-store">
                        <!-- Widget Header -->
                        <app-videotutoriales [preguntaId]="id" [respuestaId]="respuestaId"></app-videotutoriales>
                    </div>
                    <!-- Category Widget -->
                    <div class="widget category">
                        <!-- Widget Header -->
                        <app-relacionados [id]="id"></app-relacionados>
                    </div>
                    <!-- Store Widget -->
                    <div class="widget category clearfix">
                        <!-- Widget Header -->
                        <app-links [preguntaId]="id" [respuestaId]="respuestaId"></app-links>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
